import { AppSettings } from '@/types/settings';

const SETTINGS_KEY = 'qr_studio_settings_v1';

export const DEFAULT_SETTINGS: AppSettings = {
  defaultExportSize: 1024,
  defaultExportFormat: 'png',
  defaultErrorCorrection: 'H',
  historyEnabled: true,
  maxHistoryItems: 100,
  autoSaveToHistory: true,
  vibrateOnScan: true,
  soundOnScan: true,
  highContrastMode: false,
  reducedMotion: false
};

export function loadSettings(): AppSettings {
  if (typeof window === 'undefined') return DEFAULT_SETTINGS;
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return DEFAULT_SETTINGS;
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function saveSettings(settings: AppSettings): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch (err) {
    console.error('Failed to save settings:', err);
  }
}
